import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent as ArrowDown } from '../assets/icon-arrow-down-white.svg';
import './dropdown.css';

class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    }
  }
  componentDidMount() {
    document.addEventListener('click', this.handleDocumentClick, false)
    document.addEventListener('touchend', this.handleDocumentClick, false)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleDocumentClick, false)
    document.removeEventListener('touchend', this.handleDocumentClick, false)
  }

  handleDocumentClick = (event) => {
    if (!ReactDOM.findDOMNode(this).contains(event.target)) {
      this.setState({
        isOpen: false
      });
    }
  }

  handleClick = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  selectOption

  render() {
    const { text } = this.props.options.find(option => option.value === this.props.value);
    return (
      <div className="dropdown" onClick={ this.handleClick }>
        <span className="dropdown-control">{ text }</span>
        <ArrowDown />
        { this.state.isOpen && 
          <div className="dropdown-body">
            {
              this.props.options.map((option) => (
                <div onClick={ this.props.onChange.bind(null, option.value) } className="dropdown-item" key={ option.title }>
                  <div className="dropdown-title">{ option.title }</div>
                  <div className="dropdown-subtitle">{ option.subtitle }</div>
                </div>
              ))
            }
          </div>
        }
      </div>
    );
  }
}

export default Dropdown;
